import { render, staticRenderFns } from "./ContentVersionModal.vue?vue&type=template&id=3bb2bde9&scoped=true&"
import script from "./ContentVersionModal.vue?vue&type=script&lang=js&"
export * from "./ContentVersionModal.vue?vue&type=script&lang=js&"
import style0 from "./ContentVersionModal.vue?vue&type=style&index=0&id=3bb2bde9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb2bde9",
  null
  
)

export default component.exports